import React, { FC } from "react";
import { List } from "@mui/material";
import { DevTo as DevIcon } from "mdi-material-ui";
import { IRoute } from "configs";
import { useSidebar } from "hooks/useSidebar";

import * as styles from "assets/styles/drawer";
import { SidebarItem } from "./SidebarItem";
import { SidebarListCollapsable } from "./SidebarListCollapsable";
import { useAppSelector } from "store";
import { EUserType } from "@deltasge/marauders-map";

export const SidebarList: FC<{
  routes?: IRoute[];
  leftSpace: number;
}> = ({ routes, leftSpace = 0 }) => {
  const {
    layout: { devMode },
    chat: { chat, mensagens },
    usuario: { usuario: usuarioLogado },
  } = useAppSelector((state) => state);
  const { toggle } = useSidebar();

  const usuarioInterno = usuarioLogado?.tipoUsuario == EUserType.UsuarioInterno;

  if (!routes) return null;

  return (
    <List sx={styles.list}>
      {routes
        .filter(
          (r) =>
            r.showOnSidebar &&
            (!r.mode ||
              (r.mode === "dev" && devMode) ||
              (r.mode === "interno" && usuarioInterno))
        )
        .sort((a, b) => {
          if (b.label === "Novidades") return 1;
          if (b.label === "Dashboard") return 2;
          if ((a.label ?? "") < (b.label ?? "")) return -1;
          if ((a.label ?? "") > (b.label ?? "")) return 1;
          return 0;
        })
        .map((route) => {
          if (route.routes) {
            return (
              <SidebarListCollapsable
                route={route}
                key={route.label}
                leftSpace={leftSpace + 1}
                badgeContent={
                  route.path.startsWith("/publicacoes") && mensagens > 0
                    ? mensagens
                    : undefined
                }
              >
                <SidebarList routes={route.routes} leftSpace={leftSpace + 1} />
              </SidebarListCollapsable>
            );
          }
          return (
            <SidebarItem
              badgeContent={
                route.path == "/chat" && chat > 0 ? chat : undefined
              }
              key={route.path}
              {...route}
              toggle={() => toggle()}
              leftSpace={leftSpace + 1}
            />
          );
        })}
      {devMode == true && (
        <SidebarItem
          toggle={() => toggle()}
          path="/dev"
          label="Modo Desenvolvedor"
          leftSpace={leftSpace + 1}
          icon={DevIcon}
        />
      )}
    </List>
  );
};
